import clientTypeDefs from './client';

export const typeDefs = [clientTypeDefs];
